// src/api/dressApi.js

// This now points to your Node.js middleware
const MIDDLEWARE_BASE_URL = 'https://vb-prod-api-958954606691.europe-west1.run.app/api'; // Base URL for middleware API

//This would replace the current content of your getSessionToken function
// in a real scenario where you have a backend.

export const getSessionToken = async () => {
  try {
    const response = await fetch(`${MIDDLEWARE_BASE_URL}/getSessionToken`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include', 
      // body: JSON.stringify({}), // If your backend needs an empty JSON body for POST
    });

    if (!response.ok) {
      // Try to get more specific error message from backend if possible
      let errorMsg = `HTTP error! Status: ${response.status}`;
      try {
        const errorData = await response.json();
        errorMsg = errorData.message || errorData.error || errorMsg;
      } catch (e) {
        // Ignore if response body is not JSON or empty
      }
      throw new Error(errorMsg);
    }

    // For HTTP-only cookie approach, the backend sets the cookie.
    // The frontend just needs to know the call was successful.
    // The backend might return a minimal JSON like { "message": "Session initiated" } or even be empty for a 200/204.
    // We return a consistent success object for AuthProvider.

    // Optionally parse JSON if backend sends useful (non-token) info
    let responseData = {};
    try {
        responseData = await response.json();
    } catch (e) {
        // If response body is empty or not JSON, it's fine for a success if status was OK
    }

    return { 
        success: true, 
        message: responseData.message || "Session initiated successfully (cookie should be set).",
        data: responseData // Include any other data backend might send
    };

  } catch (error) {
    console.error("Error initiating session:", error);
    throw error; // Re-throw for AuthProvider to catch
  }
};

export async function fetchDressImage(promptDetails) { // For dropdown selections
  try {
    const response = await fetch(`${MIDDLEWARE_BASE_URL}/generate-dress`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(promptDetails),
      credentials: 'include' 
    });


    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.error || `HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    if (result.imageUrl) {
      console.log(`Image served. Cached: ${result.cached ? 'Yes' : 'No'}`);
      return { imageUrl: result.imageUrl, analysis: result.analysis || 'No analysis available.' };
    } else {
      throw new Error('Unexpected response structure from middleware: missing imageUrl.');
    }
  } catch (error) {
    console.error('Error fetching dress image from middleware (dropdowns):', error);
    throw error;
  }
}

export async function fetchDressImageFromUpload(base64Image) { // For uploaded image
  try {
    const response = await fetch(`${MIDDLEWARE_BASE_URL}/generate-from-upload`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ base64Image: base64Image }), // Send the base64 image
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.error || `HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    if (result.imageUrl) {
      console.log(`Image generated from upload. Analysis: ${result.analysis}`);
      return { imageUrl: result.imageUrl, analysis: result.analysis || 'No analysis available.' };
    } else {
      throw new Error('Unexpected response structure from middleware: missing imageUrl.');
    }
  } catch (error) {
    console.error('Error fetching dress image from middleware (upload):', error);
    throw error;
  }
}
